var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayAudioIcon = function SvgPlayAudioIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.36 11.83c.429-.234.95-.216 1.36.048l18.668 12a1.333 1.333 0 0 1 0 2.243l-18.667 12A1.333 1.333 0 0 1 15.666 37V13c0-.488.267-.937.695-1.17"
  })));
};
export default SvgPlayAudioIcon;